import Request from '@/jslib/dk-axios'

export const contactList = (data) => {
  return Request({
    url: 'ContactUs',
    method: 'GET',
    params: data,
  })
}
export const aboutUs = (data) => {
  return Request({
    url: 'AboutUs',
    method: 'GET',
    params: data,
  })
}
export const aboutUsEdit = (data) => {
  return Request({
    url: `AboutUs/${data.uuid}`,
    method: 'PUT',
    data,
  })
}
export const cooperateBrandList = (data) => {
  return Request({
    url: 'CooperationBrand',
    method: 'GET',
    params: data,
  })
}
export const addCooperatenBrand = (data) => {
  return Request({
    url: 'CooperationBrand',
    method: 'POST',
    data,
  })
}
export const editCooperateBrand = (data) => {
  return Request({
    url: `CooperationBrand/${data.uuid}`,
    method: 'PUT',
    data,
  })
}
export const delCooperationBrand = (data) => {
  return Request({
    url: `CooperationBrand/${data.uuid}`,
    method: 'DELETE',
    data,
  })
}
export const cooperationBrandDetail = (data) => {
  return Request({
    url: `CooperationBrand/${data.uuid}`,
    method: 'GET',
    params: data,
  })
}
export const cooperation = (data) => {
  return Request({
    url: 'StrategicCooperation',
    method: 'GET',
    params: data,
  })
}
export const cooperationEdit = (data) => {
  return Request({
    url: `StrategicCooperation/${data.uuid}`,
    method: 'PUT',
    data,
  })
}
export const buy = (data) => {
  return Request({
    url: 'Pay',
    method: 'GET',
    params: data,
  })
}
export const buyEdit = (data) => {
  return Request({
    url: `Pay/${data.uuid}`,
    method: 'PUT',
    data,
  })
}
export const maskReadContactUs = (data) => {
  return Request({
    url: 'ContactUs',
    method: 'POST',
    data,
  })
}

export const deleteContactRecord = uuid => Request({
  url: `ContactUs/${uuid}`,
  method: 'DELETE',
})



// WEBPACK FOOTER //
// ./src/api/about.js